"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _phone = require('shared/services/phone');

const onlyDigits = (s) => s.replace(/\D/g, '')

/* A masked field after an edit, and where its caret goes. */





/* Where the caret goes in a formatted value: just after its nth digit. */
const caretAfterDigits = (value, n) => {
  if (n <= 0) return 0
  let seen = 0
  for (let i = 0; i < value.length; i++) {
    if (/\d/.test(value[i]) && ++seen === n) return i + 1
  }
  return value.length
}

/* Review R800-15: an edit to a masked value, kept to the digits it touched.
 * The caret is tracked as the number of digits before it, so reformatting
 * never moves an edit onto another digit. Deleting only a separator (a
 * bracket, space, dash or slash) deletes the digit beside it instead: the
 * one before for Backspace, the one after for Delete. */
const editDigits = (
  previous,
  next,
  caret,
  inputType,
  maxDigits,
) => {
  let digits = onlyDigits(next)
  let before = onlyDigits(next.slice(0, caret)).length
  if (next.length < previous.length && digits === onlyDigits(previous)) {
    if (inputType === 'deleteContentForward') {
      digits = digits.slice(0, before) + digits.slice(before + 1)
    } else if (before > 0) {
      digits = digits.slice(0, before - 1) + digits.slice(before)
      before -= 1
    }
  }
  return { digits: digits.slice(0, maxDigits), before: Math.min(before, maxDigits) }
}

/* Rev 23 A1: a US phone as you type it, "(206) 555-0199", with the app's
 * formatter (shared/services/phone). A leading 1 is the country code. A
 * number typed with "+" is left as typed (another country's format). */
 const editPhone = (previous, next, caret, inputType) => {
  if (next.trim().startsWith('+')) return { value: next, caret }
  let { digits, before } = editDigits(previous, next, caret, inputType, 11)
  if (digits.length === 11 && digits.startsWith('1')) {
    digits = digits.slice(1)
    before = Math.max(0, before - 1)
  }
  const value = _phone.formatNationalPhoneDigits.call(void 0, null, _phone.getPhoneDigits.call(void 0, digits.slice(0, 10)))
  return { value, caret: caretAfterDigits(value, Math.min(before, 10)) }
}; exports.editPhone = editPhone

/* A value set without typing (a prefill): formatted, caret at the end. */
 const formatPhone = (text) => exports.editPhone.call(void 0, '', text, text.length).value; exports.formatPhone = formatPhone

/* Rev 23 A2: a date of birth as you type it, MM/DD/YYYY: digits only, with
 * the slashes put in. */
 const editDob = (previous, next, caret, inputType) => {
  const { digits, before } = editDigits(previous, next, caret, inputType, 8)
  const value = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4)].filter(Boolean).join('/')
  return { value, caret: caretAfterDigits(value, before) }
}; exports.editDob = editDob

const parseDob = (dob) => {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(dob)
  if (!m) return null
  const [month, day, year] = [Number(m[1]), Number(m[2]), Number(m[3])]
  const date = new Date(year, month - 1, day)
  const isReal = year >= 1900 && date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
  return { year, month, day, date, isReal }
}

/* Rev 23 B2: what's wrong with a typed date of birth, if anything. The
 * server can't read a partial or impossible date (and reads "03/14" as the
 * year 0), so it's caught in the form. */
 const dobProblem = (dob, today = new Date()) => {
  if (!dob) return null
  const parsed = parseDob(dob)
  if (!parsed) return 'Enter the date as MM/DD/YYYY'
  if (!parsed.isReal) return "That date doesn't exist"
  if (parsed.date > today) return "Date of birth can't be in the future"
  return null
}; exports.dobProblem = dobProblem

/* The date as the server is sent it, YYYY-MM-DD (as DateInput emits); '' if
 * it isn't a complete date. */
 const dobToIso = (dob) => {
  const parsed = parseDob(dob)
  if (!parsed) return ''
  const pad = (n) => String(n).padStart(2, '0')
  return `${parsed.year}-${pad(parsed.month)}-${pad(parsed.day)}`
}; exports.dobToIso = dobToIso

/* A saved date (YYYY-MM-DD) or a file's M/D/YYYY as the field shows it,
 * MM/DD/YYYY; anything else as it is (the form flags it). */
 const isoToDobInput = (dob) => {
  const iso = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dob)
  if (iso) return `${iso[2]}/${iso[3]}/${iso[1]}`
  const us = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(dob)
  return us ? `${us[1].padStart(2, '0')}/${us[2].padStart(2, '0')}/${us[3]}` : dob
}; exports.isoToDobInput = isoToDobInput
